/*
 * File: DeletePeriodEnrollment.ts
 * Author: Austin Robinson
 * Date Created: 7/25/2023
 * Copyright (c) DrivingDoc 2023
 */

import { privateApi } from 'api';
import { createMutation } from "react-query-kit";

export type DeletePeriodEnrollmentParams = {
    coursePeriodId: string;
    studentId: string;
};

async function deletePeriodEnrollment(params: DeletePeriodEnrollmentParams | undefined): Promise<boolean> {
    if (params === undefined) {
        return false;
    }

    console.time('Delete Course Periods');
    // make api call
    await privateApi.delete(`${import.meta.env.VITE_API_BASE_URL}/courses/periods/deletePeriodEnrollment`, {

        data: params
    });
    // return the data object
    return true;
}

const useDeletePeriodEnrollment = createMutation({
    mutationFn: async (variables: DeletePeriodEnrollmentParams) => deletePeriodEnrollment(variables),
});

export { deletePeriodEnrollment, useDeletePeriodEnrollment };
